import { registerPlugin } from "@capacitor/core";
import { isAndroid } from "./capacitor";

interface WidgetBridgePlugin {
  syncSession(): Promise<void>;
  setSessionId(options: { sessionId: string }): Promise<void>;
  refreshWidget(): Promise<void>;
}

const WidgetBridge = isAndroid
  ? registerPlugin<WidgetBridgePlugin>("WidgetBridge")
  : null;

/** Synchronise le cookie session vers le widget Android natif */
export async function syncWidgetSession(): Promise<void> {
  if (!isAndroid || !WidgetBridge) return;
  try {
    await WidgetBridge.syncSession();
  } catch {
    // Widget pas installé ou pas de session — on ignore
  }
}

/** Passe directement le session ID au widget Android */
export async function syncWidgetSessionWithId(sessionId: string): Promise<void> {
  if (!isAndroid || !WidgetBridge) return;
  try {
    await WidgetBridge.setSessionId({ sessionId });
  } catch {
    // Widget pas installé — on ignore
  }
}

/** Force un rafraîchissement du widget calendrier */
export async function refreshCalendarWidget(): Promise<void> {
  if (!isAndroid || !WidgetBridge) return;
  try {
    await WidgetBridge.refreshWidget();
  } catch {
    // Widget pas installé — on ignore
  }
}
